import request from '/@common/utils/request';

/**
 * （不建议写成 request.post(xxx)，因为这样 post 时，无法 params 与 data 同时传参）
 *
 * 登录api接口集合
 * @method signIn 用户登录
 * @method signOut 用户退出登录
 */
export function useLoginApi() {
	return {
		signIn: (data: object) => {
			return request({
				url: '/user/signIn',
				method: 'post',
				data,
			});
		},
		signOut: (data: object) => {
			return request({
				url: '/user/signOut',
				method: 'post',
				data,
			});
		},
		// 验证手机号是否已注册
		verifyPhone: (params: object) => {
			return request({
				url: '/api/chatLogin/isExist',
				method: 'get',
				params,
			});
		},
		// 获取验证码
		getPhoneCode: (params: object) => {
			return request({
				url: '/api/sms/send',
				method: 'post',
				params,
			});
		},
		// 登录
		login: (data: object) => {
			return request({
				url: '/api/auth/login',
				method: 'post',
				data,
			});
		},
		// 判断是否登录
		isLoginApi: (data: object) => {
			return request({
				url: `${window.$website.ADMIN_URL}/api/client/login?client_id=${data.client_id}&state=${data.state}&callback_uri=${data.callback_uri}`,
				method: 'get',
			});
		},
		//验证
		getInfoLogin: (code: string) => {
			return request({
				url: `/api/auth/login?code=${code}`,
				method: 'get',
			});
		},
		// 绑定手机号
		bindPhoneNumber: (data: object) => {
			return request({
				url: '/api/user/bindPhoneNumber',
				method: 'post',
				data,
			});
		},
		// 获取验证图片
		getVerifyImg: () => {
			return request({
				url: '/api/chatLogin/getGraphicVerify',
				method: 'get',
			});
		},

		// 验证图片
		verifyImg: (params: object) => {
			return request({
				url: '/api/chatLogin/verify',
				method: 'get',
				params,
			});
		},
		//企业微信扫码登陆参数
		loginByQROne: () => {
			return request({
				url:'/api/sso/auth/corpWxLoginParam',
				method: 'get',
			});
		},
		//登录是否失效
		isLoginExpiredApi: () => {
			return request({
				url: '/api/auth/isLoginExpired',
				method: 'get',
			});
		},
		//退出
		logout: (params: object) => {
			return request({
				url: '/api/auth/logout',
				method: 'get',
				params,
			});
		},
		// 移动端登录
		loginMobile: (data: object) => {
			return request({
				url: '/api/chatLogin/login',
				method: 'post',
				data,
			});
		},
		// 移动端登出
		loginOutMobile: (data: object) => {
			return request({
				url: '/api/chatLogin/logout',
				method: 'get',
				data,
			});
		},
		//ai绘画，长文档操作权限
		getUserOperationPermissions: () => {
			return request({
				url: `/api/auth/getUserOperationPermissions`,
				method: 'get',
			});
		},
		getUserDetail: () => {
			return request({
				url: `/api/user/getUserInfo`,
				method: 'get',
			});
		},	
	};
}
